<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div class="whitelist">
    <div class="whitelist__header">
      <button class="whitelist__create-btn" @click="handleToggleForm">
        <span class="whitelist__create-btn-icon">+</span>
        Create
      </button>
    </div>

    <div class="list-group settings" v-if="showForm">
      <div class="gitlab-user-info list-group-item">
        <div>
          <div class="mt-3">
            <div class="col mb-3">
              <label for="name" class="form-label">Name</label>
              <input type="text" class="form-control" v-model="name" id="name" />
               <span
                class="error"
                v-if="isSaved && name == ''"
                >>name is required
              </span>
            </div>
          </div>
          <div class="mt-3">
            <div class="col mb-3">
              <label for="origin" class="form-label">Origin</label>
              <input type="text" class="form-control" v-model="origin" id="origin" />
              <span
                class="error"
                v-if="isSaved && origin == ''"
                >>origin is required
              </span>
            </div>
          </div>
          <div class="mt-3">
            <div class="col mb-3">
              <label for="description" class="form-label">Description</label>
              <input type="text" class="form-control" v-model="description" id="description" />
              <span
                class="error"
                v-if="isSaved && description == ''"
                >>description is required
              </span>
            </div>
          </div>
          <div class="mt-3">
            <div class="col mb-3">
              <label for="organisation" class="form-label">Organisation</label>
              <input type="text" class="form-control" v-model="organisation" id="organisation" />
              <span
                class="error"
                v-if="isSaved && organisation == ''"
                >>organisation is required
              </span>
            </div>
          </div>
          <div class="mt-3">
            <div class="col mb-3">
              <label for="organisation" class="form-label">Tag</label>
              <input type="text" class="form-control" v-model="tag" id="tag" />
              <span
                class="error"
                v-if="isSaved && tag == ''"
                >>tag is required
              </span>
            </div>
          </div>
          <div class="mt-3">
            <div class="col mb-3">
              <button @click="createWhitelistedUser" class="ed-btn" :disabled="isSaved">
              <span v-if="isSaved" class="loader" />
              <span v-else>Save</span>
            </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="whitelist__list" v-else>
      <div v-for="user in whitelistedUsers" :key="user.id" class="whitelist__card">
        <div class="whitelist__card-header">
          <h2 class="whitelist__card-title">{{ user.name }}</h2>
          <div class="whitelist__card-actions">
            <div class="whitelist__toggle">
              <label class="whitelist__switch">
                <input type="checkbox" :checked="user.status === 'Enable'" @change="handleWhitelistedUserStatus(user.id, user.status)">
                <span class="whitelist__slider"></span>
              </label>
              <span class="whitelist__status">{{ user.status === 'Enable' ? 'Disable' : 'Enable'}}</span>
            </div>
            <button class="whitelist__delete-btn" @click="deleteWhitelistedUser(user.id)">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.75 3.5H12.25M5.25 1.75H8.75M5.83333 6.41667V10.5M8.16667 6.41667V10.5M2.91667 3.5L3.5 11.0833C3.5 11.7777 4.05562 12.3333 4.75 12.3333H9.25C9.94438 12.3333 10.5 11.7777 10.5 11.0833L11.0833 3.5" stroke="#E11D48" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            </button>
          </div>
        </div>

        <p class="whitelist__description">
          {{ expandedUsers.includes(user.id) || user.description.length <= 100
            ? user.description
            : user.description.slice(0, 100) + "..."
          }}
          <button v-if="user.description.length > 100" @click="toggleDescription(user.id)" class="whitelist__show-more">
            {{ expandedUsers.includes(user.id) ? "Show Less" : "Show More" }}
          </button>
        </p>

        <div class="whitelist__tags">
          <span v-for="tag in user.tag" :key="tag" class="whitelist__tag" :style="getTagStyle(tag)">
            {{ tag }}
          </span>
        </div>

        <div class="whitelist__date" v-if="user.timestamp && user.timestamp.humanReadable">
          📅 Created on {{ user.timestamp.humanReadable }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import '../../../assets/scss/whitelistedWidget.scss';

export default {
  name: 'UrlWhitelistingSettings',
  data() {
    return {
      name: '',
      origin: '',
      description: '',
      organisation: '',
      status: 'Enable',
      tag: '',
      showForm: false,
      whitelistedUsers: [],
      isSaved: false,
      tagColors: {},
      expandedUsers: [],
    };
  },
  async mounted() {
    await this.getWhitelistedData();
  },
  methods: {
    async createWhitelistedUser() {
      if (this.name === '' || this.origin === '' || this.description === '' || this.organisation === '' || this.tag === '') return;
      this.isSaved = true;
      const token = localStorage.getItem('userToken');
      const values = [
        [
          this.name,
          this.origin,
          this.description,
          this.organisation,
          this.status,
          this.tag.split(',').map((tag) => tag.trim()).filter((tag) => tag !== '').join(', '),
        ],
      ];

      try {
        await axios.post(
          `${process.env.VUE_APP_AXIOS_URI}/custom/edvanta-sheet`,
          { values },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          },
        );
        await this.getWhitelistedData();
        this.clearForm();
        this.showForm = false;
        this.isSaved = false;
      } catch (err) {
        console.error('Error:', err.message);
      }
    },
    async deleteWhitelistedUser(userId) {
      const index = this.whitelistedUsers.findIndex((user) => user.id === userId);
      const startIndex = index + 1;
      const endIndex = index + 2;
      try {
        await axios.post(
          `${process.env.VUE_APP_AXIOS_URI}/custom/edvanta-sheet/delete-row`,
          {
            startIndex, endIndex,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
        await this.getWhitelistedData();
      } catch (err) {
        console.error('Error:', err.message);
      }
    },
    async handleWhitelistedUserStatus(userId, currentStatus) {
      const index = this.whitelistedUsers.findIndex((user) => user.id === userId);
      const newStatus = currentStatus === 'Enable' ? 'Disable' : 'Enable';
      this.whitelistedUsers[index].status = newStatus;

      const rowNumber = index + 2;

      try {
        await axios.post(
          `${process.env.VUE_APP_AXIOS_URI}/custom/edvanta-sheet/update-cell`,
          { value: newStatus, rowNumber },
          { headers: { 'Content-Type': 'application/json' } },
        );
        await this.fetchWhitelistedUsers();
      } catch (err) {
        console.error('Error:', err.message);
      }
    },
    handleToggleForm() {
      this.showForm = !this.showForm;
    },
    clearForm() {
      this.name = '';
      this.origin = '';
      this.description = '';
      this.organisation = '';
      this.tag = '';
    },
    generateRandomColor() {
      const hue = Math.floor(Math.random() * 360);
      return {
        background: `hsl(${hue}, 70%, 95%)`,
        text: `hsl(${hue}, 70%, 35%)`,
      };
    },
    getTagStyle(tag) {
      if (!this.tagColors[tag]) {
        this.tagColors[tag] = this.generateRandomColor();
      }
      return {
        backgroundColor: this.tagColors[tag].background,
        color: this.tagColors[tag].text,
      };
    },
    toggleDescription(userId) {
      if (this.expandedUsers.includes(userId)) {
        this.expandedUsers = this.expandedUsers.filter((id) => id !== userId);
      } else {
        this.expandedUsers.push(userId);
      }
    },
    async addWhitelistedData() {
      const token = localStorage.getItem('userToken');
      const values = [
        [
          this.name,
          this.origin,
          this.description,
          this.organisation,
          this.status,
          this.tag.split(',').map((tag) => tag.trim()).filter((tag) => tag !== '').join(', '),
        ],
      ];

      try {
        await axios.post(
          `${process.env.VUE_APP_AXIOS_URI}/custom/edvanta-sheet`,
          { values },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          },
        );
        await this.fetchWhitelistedUsers();
      } catch (err) {
        console.error('Error:', err.message);
      }
    },
    async getWhitelistedData() {
      const token = localStorage.getItem('userToken');

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_AXIOS_URI}/custom/edvanta-sheet`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          },
        );

        const sheetData = response.data.MySheet.values;
        if (!sheetData || sheetData.length < 2) {
          this.whitelistedUsers = [];
          return;
        }
        const headers = sheetData[0];

        this.whitelistedUsers = sheetData.slice(1).map((row) => {
          const userObject = {};
          headers.forEach((header, index) => {
            userObject[header] = row[index] || '';
          });
          userObject.tag = userObject.tag ? userObject.tag.split(',').map((tag) => tag.trim()) : [];

          userObject.timestamp = {
            machineReadable: userObject['timestamp.machineReadable'] || '',
            humanReadable: userObject['timestamp.humanReadable'] || '',
          };

          return userObject;
        });
      } catch (err) {
        console.error('Error fetching data from Google Sheets:', err.message);
      }
    },

  },
};
</script>

<style lang="scss">
.error {
  color: red;
  font-style: italic;
  font-size: 10px;
}
.bin {
  color: red;
  font-size: 16px;
  cursor: pointer;
}
.loader {
  width: 16px;
  height: 16px;
  border: 2px solid white;
  border-top: 2px solid #333;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
